import React from 'react';
import { ChevronLeftIcon, CheckCircleIcon } from 'lucide-react';
export const VerificationComplete = ({
  onBack,
  onNext
}) => {
  return <div className="flex flex-col p-6 flex-grow bg-white" data-id="element-515">
      <div className="flex items-center mb-6" data-id="element-516">
        <button onClick={onBack} className="mr-4" data-id="element-517">
          <ChevronLeftIcon size={24} data-id="element-518" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-519">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-520"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-521"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-522"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-523"></div>
        </div>
      </div>
      <div className="flex-grow flex flex-col items-center justify-center" data-id="element-524">
        <h1 className="text-3xl font-bold mb-4 text-center" data-id="element-525">
          Verification complete
        </h1>
        <p className="text-gray-700 mb-8 text-center max-w-xs" data-id="element-526">
          Thank you! The hard part is over. Please confirm the following
          information we have is correct.
        </p>
      </div>
      <div className="mt-auto" data-id="element-527">
        <button className="w-full py-3 rounded-full font-medium text-white bg-[#4040f2]" onClick={onNext} data-id="element-528">
          CONTINUE
        </button>
      </div>
    </div>;
};